export const BACKEND_ENDPOINT = "https://etdev.docubay.com/backend";
export const AUTH_TOKEN = "1kvDk3lKVKPTIX7nG3kcYhZaZKwnpv33";
export const SECRET_KEY = "DOCUBAY@WEB@APP@123";
export const RAZORPAY_KEY = "rzp_live_gRWDL5aef1YKFa";
export const FRONT_END = "https://etdev.docubay.com/";
export const Image_Url = "https://source.docubay.com/docubay-revamp-images/web-assets/";
